<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <span class="configurationBannerLabel">Fan Curve Performance Summary</span>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <table class="data-table">
        <thead>
          <tr>
            <th class="header-cell">ACFM</th>
            <th class="header-cell">TSP (inWc)</th>
            <th class="header-cell">ESP (inWc)</th>
            <th class="header-cell">SCFM</th>
            <th class="header-cell">RPM</th>
            <th class="header-cell">Estimated CV (VDC)</th>
            <th class="header-cell">Power (W)</th>
            <th class="header-cell">Power (HP)</th>
            <th class="header-cell">FEI</th>
          </tr>
        </thead>
        <tbody>
          @for (entry of performanceSummary(); track entry.RPM) {
            <tr [class.highlighted]="isOperatingPoint(entry)">
              <td class="data-cell">{{ entry.ActualAirflow.toFixed(0) }}</td>
              <td class="data-cell">{{ entry.TSP }}</td>
              <td class="data-cell">{{ entry.ESP }}</td>
              <td class="data-cell">{{ entry.Airflow }}</td>
              <td class="data-cell">{{ entry.RPM }}</td>
              <td class="data-cell">{{ entry.ControlVoltage }}</td>
              <td class="data-cell">{{ entry.Wattage }}</td>
              <td class="data-cell">{{ entry.Horsepower }}</td>
              <td class="data-cell">{{ entry.FanEnergyIndex }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
